import React from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './Header.module.scss';

export const Button: React.FC<{
  onClick: () => void;
  loading: boolean;
  invalid: boolean;
}> = ({ onClick, loading, invalid }) => {
  const { t } = useTranslation();
  return (
    <div className={clsx([styles.buttonContainer, loading || invalid ? styles.buttonContainerInvalid : ''])}>
      <button
        className={styles.button}
        onClick={onClick}
        disabled={invalid}
        data-cy="searchBar-searchButton"
      >
        {loading ? t('header.button_loading') : t('header.button')}
      </button>
    </div>
  );
};

export const Input: React.FC<{
  value: string;
  placeholder: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  loading: boolean;
  invalid: boolean;
}> = ({ value, placeholder, onChange, onSubmit, loading, invalid }) => {
  return (
    <div className={styles.inputContainer}>
      <input
        type="text"
        className={styles.input}
        onChange={(e) => {
          if (!loading) {
            onChange(e.target.value);
          }
        }}
        onKeyUp={(e) => {
          if (!invalid && e.key === 'Enter') {
            onSubmit();
          }
        }}
        value={value}
        placeholder={placeholder}
        data-cy="searchBar-input"
      />
    </div>
  );
};

export const Tab: React.FC<{ label: string; active: boolean; onClick: () => void; id: string }> = ({
  label,
  active,
  onClick,
  id,
}) => {
  return (
    <button
      className={clsx(styles.tabContainer, active ? styles.tabActive : '')}
      onClick={onClick}
      // TODO: To update search to captical Search
      data-cy={`searchBar-tab__${id}`}
    >
      <div className={styles.tabText}>{label}</div>
    </button>
  );
};
